import React from 'react';

const FORMS = {
  contributrice: { fr: 'Contributrice', en: 'Contributor' },
  contributeur:  { fr: 'Contributeur',  en: 'Contributor' },
  contribue:     { fr: 'Contribue',     en: 'Contributor' },
};

export default function ContributorBadge({
  language = 'fr',
  form = 'contribue',   // 'contributrice' | 'contributeur' | 'contribue' - default non-genre (decision produit)
  size = 'md',          // 'md' (Home/Profil) | 'sm' (Mur)
  className = '',
}) {
  const safeForm = FORMS[form] ? form : 'contribue';  // fallback non-genre
  const word = FORMS[safeForm][language === 'en' ? 'en' : 'fr'];
  const label = `${word} \u{1F49B}`;

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-[9px]'
    : 'px-2.5 py-1 text-[10px]';

  return (
    <span
      className={`inline-flex items-center rounded-full font-bold bg-[linear-gradient(135deg,rgba(232,168,124,0.22),rgba(212,165,165,0.2))] border border-[rgba(232,168,124,0.4)] text-[color:var(--cb-text)] ${sizeClasses} ${className}`.trim()}
    >
      {label}
    </span>
  );
}
